var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import "./pageHeader.css";
import Button from "../../atoms/button/button";
import { ButtonType } from "../../atoms/button/buttonType";
import Card from "../../atoms/card/card";
import { ArrowType } from "../../atoms/card/arrowType";
import user from "../../../assets/user.png";
import SectionHeader from "../../atoms/sectionHeader/sectionHeader";
var PageHeader = function (props) {
    var _a;
    var navigate = useNavigate();
    var headerClass = props.sticky ? "page-header-sticky" : "";
    var _b = useState(false), isEditing = _b[0], setIsEditing = _b[1];
    var _c = useState(props.editable || ""), input = _c[0], setInput = _c[1];
    useEffect(function () {
        setInput(props.editable || "");
    }, [props.editable]);
    var handleBlur = function () {
        setIsEditing(false);
        var trimmed = input.trim();
        if (trimmed && props.onNameChange) {
            props.onNameChange(trimmed);
        }
        else {
            setInput(props.editable || "");
        }
    };
    var handleKeyDown = function (e) {
        if (e.key === "Enter")
            e.currentTarget.blur();
        if (e.key === "Escape") {
            setInput(props.editable || "");
            setIsEditing(false);
        }
    };
    var titleContent = props.editable ? (_jsxs("div", __assign({ className: "flex items-center gap-x-2" }, { children: [isEditing ? (_jsx("input", { className: "section-header align-middle my-auto font-bold outline-none bg-transparent", style: { borderBottom: "2px solid var(--primary)" }, value: input, autoFocus: true, onChange: function (e) { return setInput(e.target.value); }, onBlur: handleBlur, onKeyDown: handleKeyDown })) : (_jsxs("span", __assign({ className: "section-header align-middle my-auto cursor-pointer hover:underline", style: (_a = {}, _a["--hover-color"] = "var(--primary)", _a), title: "Click to edit name", onClick: function () { return setIsEditing(true); }, onMouseEnter: function (e) { return (e.currentTarget.style.color = "var(--primary)"); }, onMouseLeave: function (e) { return (e.currentTarget.style.color = ""); } }, { children: [input, "'s"] }))), _jsx("span", __assign({ className: "section-header mx-0" }, { children: " Dashboard" }))] }))) : null;
    return (_jsxs("div", __assign({ className: headerClass }, { children: [_jsxs("div", __assign({ className: "flex flex-row flex-wrap gap-y-2 topbar justify-between align-middle" }, { children: [_jsxs("div", __assign({ className: "flex flex-row items-center gap-x-6" }, { children: [props.backButton && (_jsx(Button, __assign({ className: "py-3", buttonType: ButtonType.Filled, onClick: props.onClick
                                    ? props.onClick
                                    : function () {
                                        navigate("/" + props.backTo);
                                    } }, { children: _jsx(Card, __assign({ arrowType: ArrowType.Left, transarent: true, className: "p-0 m-0" }, { children: _jsx("p", __assign({ className: "text-lg" }, { children: props.backButton })) })) }))), titleContent
                                ? _jsx("div", __assign({ className: "section-header align-middle my-auto" }, { children: titleContent }))
                                : _jsx(SectionHeader, { title: props.title })] })), _jsx("div", __assign({ className: "flex flex-row align-middle" }, { children: _jsx(Button, __assign({ className: "mx-3 profile-img", onClick: function () { return navigate("/profile"); }, buttonType: ButtonType.Tertiary }, { children: _jsx("img", { src: user }) })) }))] })), _jsx("div", { className: "hr" })] })));
};
export default PageHeader;
